var map = {
	"./btn_bg.png": 7653,
	"./burning.png": 3182,
	"./count.png": 8634,
	"./heart-circle.png": 3206,
	"./high.png": 9299,
	"./high_btn.png": 9518,
	"./icon-fire.png": 8479,
	"./icon-time.png": 1851,
	"./icon_down.png": 4849,
	"./icon_nochange.png": 4988,
	"./icon_rate.png": 2767,
	"./icon_sugar.png": 583,
	"./icon_sugar_gery.png": 4711,
	"./icon_up.png": 9490,
	"./low.png": 673,
	"./low_btn.png": 8352,
	"./m_high+.png": 1376,
	"./m_high+_btn.png": 657,
	"./m_high.png": 4219,
	"./m_high_btn.png": 1958,
	"./m_low.png": 7881,
	"./m_low_btn.png": 2952,
	"./medium.png": 1114,
	"./medium_btn.png": 3199,
	"./time.png": 5100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4852;